const initialState = {
    portals: { loading: false, data: [], error: null }
};

export default function apiReducer(state = initialState, action) {
    switch (action.type) {
        case "PORTALS_LOADING":
            return { ...state, portals: { loading: true, data: [], error: null } };
        case "PORTALS_SUCCESS":
            return { ...state, portals: { loading: false, data: action.payload, error: null } };
        case "PORTALS_ERROR":
            return { ...state, portals: { loading: false, data: [], error: action.payload } };
        
        case "PORTAL_COUNTS_LOADING":
            return { ...state, portalCounts: { loading: true, data: [], error: null } };
        case "PORTAL_COUNTS_SUCCESS":
            return { ...state, portalCounts: { loading: false, data: action.payload, error: null } };
        case "PORTAL_COUNTS_ERROR":
            return { ...state, portalCounts: { loading: false, data: [], error: action.payload } };
        default:
            return state;
    }
}
